import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import Icon24 from 'builder/components/Icon'
import { ButtonSize, ButtonV2 } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { actions, AutoTailoringMode, selectors } from 'builder/modules/resumeEditor'
import { useAutoTailoring } from 'builder/components/AutoTailoring/hooks/useAutoTailoring'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useStepByStepFlow } from '../../StepByStepFlow/hooks/useStepByStepFlow'

export const StartTailoringButton = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { isFinishStep, isRbpStepFlowActive } = useStepByStepFlow()
  const { isDataMissed } = useAutoTailoring()
  const isDisabled = isRbpStepFlowActive && !isFinishStep
  const { mode } = useTypedSelector(selectors.autoTailoringFromPublicJobBoard)

  const handleClick = () => {
    if (isDataMissed) {
      dispatch(actions.setOpenOptimizerModal(true))
      return
    }

    trackInternalEvent('click_start_tailoring')

    if (mode === AutoTailoringMode.fromMemberJB) {
      dispatch(actions.setAutoTailoringModalStep('keywords_selection'))
    } else {
      dispatch(actions.autoTailorForPublicJobBoard())
    }
  }

  return (
    <ButtonV2
      leadingIcon={<Icon24.ArrowTargetAutoTailoring />}
      onClick={handleClick}
      size={ButtonSize.small}
      isDisabled={isDisabled}
      data-testid="start-tailoring-button"
    >
      {i18n.t('builder.prefill_resume.auto_tailoring_view.start_tailoring')}
    </ButtonV2>
  )
}
